<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';
import HomepageBtn from './HomepageBtn.vue';

const { $i18n } = useTranslations('components/homepage/explore_service_provider');
const emit = defineEmits(['exploreServiceProvider']);
</script>
<template>
  <div class="explore-service-provider-container">
    <div
      class="flex flex-column explore-service-provider-content px-30px py-70px py-40px--sm grid-gap-40px align-items-center justify-center"
    >
      <h2 class="title text-center--sm">
        {{ $i18n('aGlobalEcosystem') }}
      </h2>
      <div class="content text-center--sm text-content">
        {{ $i18n('connect') }}
      </div>
      <HomepageBtn color="white" @click="emit('exploreServiceProvider')">
        {{ $i18n('exploreServiceProviders') }}
      </HomepageBtn>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@use '/assets/scss/variables' as variables;

* {
  color: white;
}

.explore-service-provider-container {
  background-image: url('/assets/images/homepage/service-providers.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}

.explore-service-provider-content {
  width: 50%;
  background-color: rgba(54, 142, 196, 0.85);

  @include variables.for-sm {
    width: 100%;
  }
}
</style>
